export default "__VITE_ASSET__$sD1rIv3__"